import React from "react";
import { ISubHeadingData } from "../../exports/interfaces";

const DynamicSurgicalBanner = (props: {bannerData: ISubHeadingData, page: string}) => {
  return (
    <section className="page-header" style={{ marginTop: "71px" }}>
      <div
        className="page-header-bg"
        style={{
          backgroundImage: props?.bannerData?.attributes?.Banner_Image?.data?.attributes?.url && `url(${process.env.REACT_APP_strapiUrl}${props?.bannerData?.attributes?.Banner_Image?.data?.attributes?.url})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
        }}
      ></div>
      <div className="container">
        <div className="page-header__inner">
          <h2>{props?.bannerData?.attributes?.Sub_Heading_Name}</h2>
          <ul className="thm-breadcrumb list-unstyled">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <span>/</span>
            </li>
            <li className="active">{props.page}</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default DynamicSurgicalBanner;
